import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import PriceParrotService from '~/services/PriceParrotService';

import { BulkCreateSfOpportunitiesBody } from '~/types/services/priceParrot';

import { controlCentreQueryKeys } from './controlCentreQueryKeys';

export function useBulkCreateSfOpportunities() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (body: BulkCreateSfOpportunitiesBody) => {
      return await PriceParrotService.bulkCreateSfOpportunities(body);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: controlCentreQueryKeys.all });
      const message =
        data.failed > 0
          ? `Created ${data.created} SF cases, ${data.failed} failed`
          : `Created ${data.created} SF cases successfully`;
      enqueueSnackbar(message, { variant: data.failed > 0 ? 'warning' : 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to bulk create SF cases: ${error.message || 'Unknown error'}`, {
        variant: 'error',
      });
    },
  });
}
